import { lazyLoad } from "$routes/_lib/lazy-load";
import { Route, Routes } from "react-router-dom";

const PatientSearchLayout = lazyLoad(() =>
  import(
    /* webpackChunkName: "PatientSearch" */
    "./chunk"
  ).then((module) => ({ default: module.default.PatientSearchLayout })),
);

const PatientSearch = lazyLoad(() =>
  import(
    /* webpackChunkName: "PatientSearch" */
    "./chunk"
  ).then((module) => ({ default: module.default.PatientSearchPage })),
);

const PatientsSearchResults = lazyLoad(() =>
  import(
    /* webpackChunkName: "PatientSearch" */
    "./chunk"
  ).then((module) => ({ default: module.default.PatientsSearchResultsPage })),
);

export const PatientSearchRoutes = () => {
  return (
    <Routes>
      <Route element={<PatientSearchLayout />}>
        <Route index element={<PatientSearch />} />
        <Route path="results" element={<PatientsSearchResults />} />
      </Route>
    </Routes>
  );
};
